export default {
  labels: {
    invoice: 'Fatura',
    on_site: 'Pagar no local (Dinheiro/Cartão)',
  },
};
